import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { NWName } from '../../../../../components/NetworkSystem/cellFormatters/valueFormatters';
import CommonTableGraph from '../../../../charts/CommonTableGraph';
const NetworkHistoryTable = ({ networkHistory = [] }) => {
    let tableFormat = networkHistory.map((row) => {
        return { Network: NWName(row.provider, undefined, undefined, undefined), _Time: row.timestamp };
    });
    if (tableFormat.length === 0) {
        tableFormat = [{ Network: 'No network found', _Time: undefined }];
    }
    return _jsx(CommonTableGraph, { data: tableFormat });
};
export default NetworkHistoryTable;
